import { LOADER} from "../../resources/actionTypes";

export const onLoaderTrigger = (payload) => {

    return {
        type: LOADER.LOADER_SHOW,
        payload: payload
      };
   }


